import React from 'react'

import {WineInfoTE} from '../../components/modules/accordion/WineInfo';
import {WineTerroirTE} from '../../components/modules/accordion/WineTerroir';
import {WineCellerTE} from '../../components/modules/accordion/WineCeller';
import {WineEttColtTE} from '../../components/modules/accordion/WineEttColt';
import {WineBottlesTE} from '../../components/modules/accordion/WineBottles';

function Teramo({data}) {
    return (
        <>
            {data[0] && <WineInfoTE />}
            {data[1] && <WineTerroirTE />}
            {data[2] && <WineCellerTE />}
            {data[3] && <WineEttColtTE />}
            {data[4] && <WineBottlesTE />}            
        </>
    )
}

export default Teramo;
